/**
 * An instructor's role inside their organization. Serialized as PascalCase
 * strings on the wire (JsonStringEnumConverter).
 */
export enum OrganizationRole {
  Owner = "Owner",
  Admin = "Admin",
  Instructor = "Instructor",
}
